// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e8fc65a6","796":"4ae9c59f"}[chunkId] + ".chunk.js";
};